module.exports = __webpack_public_path__ + "img/right.301e864a.svg";